export default __webpack_public_path__ + "static/media/logoMobile.1b06bd40.svg";